/* Supplement the native product component; never intercept variant or cart submissions. */
const getViennaProcessingDate = (now = new Date()) => {
  const todayParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Vienna', year: 'numeric', month: 'numeric', day: 'numeric'
  }).formatToParts(now);
  const parts = Object.fromEntries(todayParts.map(({ type, value }) => [type, value]));
  const dateKey = `${parts.year}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
  const tomorrow = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1, 12));
  const text = new Intl.DateTimeFormat('de-AT', {
    timeZone: 'Europe/Vienna', day: '2-digit', month: '2-digit'
  }).format(tomorrow);
  return { dateKey, text: `morgen, ${text}` };
};

if (typeof module !== 'undefined' && module.exports) module.exports = { getViennaProcessingDate };

if (typeof document !== 'undefined') (() => {
  const updateProcessingDate = (root) => {
    const dateNode = root.querySelector('[data-en-pdp-processing-date]');
    if (!dateNode) return;
    try {
      const nextDate = getViennaProcessingDate();
      if (dateNode.dataset.enPdpDateKey === nextDate.dateKey) return;
      dateNode.dataset.enPdpDateKey = nextDate.dateKey;
      dateNode.textContent = nextDate.text;
    } catch (_) {
      dateNode.textContent = 'morgen';
      delete dateNode.dataset.enPdpDateKey;
    }
  };

  const mount = (root) => {
    updateProcessingDate(root);
    if (!root.dataset.enPdpMounted) {
      root.dataset.enPdpMounted = 'true';
      root.addEventListener('theme:variant:change', (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;
        const badge = root.querySelector('[data-en-pdp-sale-badge]');
        const onSale = variant.compare_at_price > variant.price;
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}% RABATT`;
        }
        const availability = root.querySelector('[data-en-pdp-availability]');
        if (availability) {
          availability.hidden = !variant.available;
          const stockCopy = availability.querySelector('[data-en-pdp-stock-copy]');
          if (stockCopy) stockCopy.textContent = 'Auf Lager und bestellbar.';
        }
      });
    }
  };
  const init = () => { document.querySelectorAll('.elaine-parity-pdp').forEach(mount); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) init(); });
  window.setInterval(() => {
    document.querySelectorAll('.elaine-parity-pdp').forEach(updateProcessingDate);
  }, 60 * 1000);
})();
